<template>
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="6">
                        Medios de verificación
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNueva"
                        >
                            Crear nuevo MV
                        </v-btn>
                    </v-col> 
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>

                <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12">
                        <v-text-field
                            outlined
                            autocomplete="off"
                            dense
                            v-model="tableFilter"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>
                </v-row>
                
                <v-data-table
                        :headers="headers"
                        :items="medios"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="tableFilter"
                        :items-per-page="10"
                        dense
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.codigo }}</td>
                            <td>{{ item.nombre }}</td>
                            <td>{{ item.descripcion }}</td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>




    <!-- Inicio:: Dialog para mostrar los datos de la puesto-->
    <v-dialog
        v-model="dialog"
        max-width="600px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                maxlength="150"
                                v-model="datosMedio.nombre"
                                label="Nombre del medio de verificación"
                                :rules="[
                                    required('Nombre del medio de verificación'),
                                    minLength('Medio de verificación', 5)
                                ]"
                            ></v-text-field>
                        </v-col>

                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                maxlength="50"
                                v-model="datosMedio.codigo"
                                label="Código del medio de verificación"
                                :rules="[
                                    required('Código del medio de verificación'),
                                    minLength('Código medio de verificación', 3)
                                ]"
                            ></v-text-field>
                        </v-col>

                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                            <v-textarea
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                rows="3"
                                maxlength="2500"
                                v-model="datosMedio.descripcion"
                                label="Descripción del medio de verificación"
                                :rules="[
                                    required(
                                        'Descripción'
                                    ),

                                    maxLength('Descripción', 2500)
                                ]"
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                             <template>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                             </template>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la medio verificacion-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_MEDIOS_VERIFICACION, OBTENER_MEDIO_VERIFICACION, REGISTRAR_MEDIO_VERIFICACION, ACTUALIZAR_MEDIO_VERIFICACION } from "@/core/services/store/preguntas/mediosverificacion/medioverificacion.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

export default {
    name: "AdminMediosVerificacion",
    components: {
        SnackAlert,
        DialogLoader
    },
    data() {
        return {
            validForm:false,
            itemName : "Medios Verificación",
            dialog: false,
            modalTitle: 'Registrar Medio Verificación',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar MV',
            accion: 1,
            medios: [],
            switchItemEstado: true,
            tableFilter:'',
            datosMedio: {
                id: 0,
                nombre: '',
                codigo: '',
                descripcion: '',
                estadosId: 1
            },
            tableLoading: false,
            ...validations
        } 
    }, 
    methods: {
        modalNueva(){
            this.accion =1;
            this.modalTitle='Registrar Medio de Verificación';
            this.btnRegistroText='Registrar MV';
            this.switchItemEstado=true;
            this.dialog=true;
        },

        resetForm(){
           // this.$refs.form.reset();
           
            this.datosMedio ={
                id: 0,
                nombre: '',
                codigo: '',
                descripcion: '',
                estadosId: 1
            },
            this.switchItemEstado = true;
        },

        //!Obtener las etnias para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.medios=[];
            
            this.$store
                .dispatch(OBTENER_MEDIOS_VERIFICACION, 0)
                .then(res => {
                    if(res.status===200){
                    this.medios = this.$store.state.medioverificacion.mediosVerificacion;
                    }
                    this.tableLoading =false;
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosMedio.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Medio Verificación';
            this.btnRegistroText='Actualizar MV';

            this.$store
                .dispatch(OBTENER_MEDIO_VERIFICACION, Id)
                .then(res => {
                    if(res.status===200){
                        this.datosMedio = this.$store.state.medioverificacion.medioVerificacion;
                        this.datosMedio.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.dialog = true;
                    } else {
                        let message = 'Ha ocurrido un error, por favor, ponte en contacto con un administrador del sistema.';
                        if(res.message){
                            message = res.message;
                        }
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', message);
                    }
                    this.dialogLoaderVisible = false;
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error, por favor, ponte en contacto con un administrador del sistema. REF: ${error}`);
                });
        },

        registrarItem(){
            this.btnRegistroLoading=true;

            this.switchItemEstado ? this.datosMedio.estadosId = 1 : this.datosMedio.estadosId = 2;

            if(this.accion===1){
                this.datosMedio.id = 0;
                this.$store
                    .dispatch(REGISTRAR_MEDIO_VERIFICACION, this.datosMedio)
                    .then(res => {
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error, por favor, ponte en contacto con un administrador del sistema. REF: ${error}`);
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_MEDIO_VERIFICACION, this.datosMedio)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            //this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error, por favor, ponte en contacto con un administrador del sistema. REF: ${error}`);
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Inicio", route: "/dashboard" },
            { title: "Catalogos" },
            { title: "Medios Verificación" }
        ]);
    },

    created(){
        this.obtnenerItems();
    },

    
    computed: {
        headers() {
            return [
                {
                    text: "Código MV",
                    align: "start",
                    sortable: true,
                    value: "codigo"
                },
                {
                    text: "Nombre MV",
                    value: "nombre"
                },
                {
                    text: "Descripción",
                    value: "descripcion"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }

    
}
</script>
<style lang="">
    
</style>